var exports = {
  "K": "commit-discussion-comments__0qIXks",
  "W": "discussion-comments-rose__O6jSGY",
};

module.exports = exports;
